<template>
    <v-progress-linear
        :color="getColor(value)"
        :height="height"
        :value="value"
        reactive
    >
        <div class="progressbar-content">
            <div class="content" :style="getWidth(value)">{{value}}%</div>
        </div>
    </v-progress-linear>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    name: "VerifyMobile",
    props: ["value", "height"],
    methods: {
        getWidth(value) {
            if (value > 5) {
                let width = value - 0.5;
                return { width: width + "%", textAlign: 'right' };
            } else {
                let padding = value + 1;
                return { paddingLeft: padding + "%", textAlign: 'left' };
            }
        },
        getColor(percentage) {
            let color = "";
            if (percentage > 65) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
            } else if (percentage > 19) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
            } else {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
            }
            return color;
        }
    }
};
</script>

